"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DualStructureCateType = exports.DualStructureOrderType = exports.DCMActivityDisableCode = exports.DCMActivityDisableDetails = exports.DCMBonusType = exports.DCMActivityName = exports.DCMActivityType = exports.DualOrderFilterType = exports.DualSettlementStatus = exports.DualInvestTag = exports.DualInvestmentStatus = void 0;
// 申购订单状态
var DualInvestmentStatus;
(function (DualInvestmentStatus) {
    DualInvestmentStatus["SUBMITTED"] = "SUBMITTED";
    DualInvestmentStatus["CONFIRMED"] = "CONFIRMED";
    DualInvestmentStatus["FILLED"] = "FILLED";
    DualInvestmentStatus["PARTIAL_FILLED"] = "PARTIAL_FILLED";
    DualInvestmentStatus["CANCELED"] = "CANCELED";
    DualInvestmentStatus["REJECTED"] = "REJECTED";
})(DualInvestmentStatus || (exports.DualInvestmentStatus = DualInvestmentStatus = {}));
var DualInvestTag;
(function (DualInvestTag) {
    DualInvestTag[DualInvestTag["takeProfit"] = 1] = "takeProfit";
    DualInvestTag[DualInvestTag["dualCoin"] = 2] = "dualCoin";
    DualInvestTag[DualInvestTag["buyTheDip"] = 3] = "buyTheDip";
    DualInvestTag[DualInvestTag["takeProfitAuto"] = 101] = "takeProfitAuto";
    DualInvestTag[DualInvestTag["dualCoinAuto"] = 102] = "dualCoinAuto";
})(DualInvestTag || (exports.DualInvestTag = DualInvestTag = {}));
var DualSettlementStatus;
(function (DualSettlementStatus) {
    DualSettlementStatus["UNSETTLED"] = "UNSETTLED";
    DualSettlementStatus["SETTLING"] = "SETTLING";
    DualSettlementStatus["SETTLED"] = "SETTLED";
    DualSettlementStatus["PAID"] = "PAID";
    DualSettlementStatus["APPLIED"] = "APPLIED";
    DualSettlementStatus["ABANDONED"] = "ABANDONED";
})(DualSettlementStatus || (exports.DualSettlementStatus = DualSettlementStatus = {}));
var DualOrderFilterType;
(function (DualOrderFilterType) {
    DualOrderFilterType["OPEN"] = "OPEN";
    DualOrderFilterType["CLOSE"] = "CLOSE";
    DualOrderFilterType["ALL"] = "ALL";
})(DualOrderFilterType || (exports.DualOrderFilterType = DualOrderFilterType = {}));
// 结构理财用户活动枚举
var DCMActivityType;
(function (DCMActivityType) {
    DCMActivityType["user_adv"] = "user_adv";
    DCMActivityType["bonus_invest"] = "bonus_invest";
    DCMActivityType["user_first"] = "user_first";
})(DCMActivityType || (exports.DCMActivityType = DCMActivityType = {}));
// 结构理财用户活动名字枚举
var DCMActivityName;
(function (DCMActivityName) {
    DCMActivityName["user_adv"] = "user_adv";
    DCMActivityName["bonus_invest"] = "bonus_invest";
    DCMActivityName["user_adv_lrc"] = "user_adv_lrc";
    DCMActivityName["user_adv_xrp"] = "user_adv_xrp";
})(DCMActivityName || (exports.DCMActivityName = DCMActivityName = {}));
// 结构理财分享活动
var DCMBonusType;
(function (DCMBonusType) {
    DCMBonusType["invite_bonus"] = "invite_bonus";
})(DCMBonusType || (exports.DCMBonusType = DCMBonusType = {}));
/**
 * 返回值新增extra字段
 * 里面disable_detail
 */
var DCMActivityDisableDetails;
(function (DCMActivityDisableDetails) {
    DCMActivityDisableDetails["DualInternalErrorMsg"] = "DualInternalErrorMsg";
    DCMActivityDisableDetails["DualAlreadyJoinMsg"] = "DualAlreadyJoinMsg";
    DCMActivityDisableDetails["DualAlreadyHasOrderMsg"] = "DualAlreadyHasOrderMsg";
    DCMActivityDisableDetails["DualKycForbiddenMsg"] = "DualKycForbiddenMsg";
})(DCMActivityDisableDetails || (exports.DCMActivityDisableDetails = DCMActivityDisableDetails = {}));
// 结构理财用户活动状态枚举
var DCMActivityDisableCode;
(function (DCMActivityDisableCode) {
    DCMActivityDisableCode[DCMActivityDisableCode["enabled"] = 0] = "enabled";
    DCMActivityDisableCode[DCMActivityDisableCode["database_error"] = 50001300] = "database_error";
    DCMActivityDisableCode[DCMActivityDisableCode["already_use"] = 40900600] = "already_use";
    DCMActivityDisableCode[DCMActivityDisableCode["key_disable"] = 40300930] = "key_disable";
    DCMActivityDisableCode[DCMActivityDisableCode["adv_not_start"] = 40600600] = "adv_not_start";
    DCMActivityDisableCode[DCMActivityDisableCode["adv_expired"] = 40600601] = "adv_expired";
})(DCMActivityDisableCode || (exports.DCMActivityDisableCode = DCMActivityDisableCode = {}));
// 双币理财申购单子类型
var DualStructureOrderType;
(function (DualStructureOrderType) {
    DualStructureOrderType["dual_manual"] = "dual_manual";
    DualStructureOrderType["dual_auto"] = "dual_auto";
    DualStructureOrderType["dual_activity"] = "dual_activity";
    DualStructureOrderType["week_win_manual"] = "week_win_manual";
})(DualStructureOrderType || (exports.DualStructureOrderType = DualStructureOrderType = {}));
// 双币理财订单子类型
var DualStructureCateType;
(function (DualStructureCateType) {
    DualStructureCateType["covered_gain"] = "covered_gain";
    DualStructureCateType["dual_invest"] = "dual_invest";
    DualStructureCateType["dual_activity"] = "dual_activity";
    DualStructureCateType["week_win"] = "week_win";
    DualStructureCateType["auto_bottom_gain"] = "auto_bottom_gain";
    DualStructureCateType["auto_covered_gain"] = "auto_covered_gain";
    DualStructureCateType["auto_target_currency"] = "auto_target_currency";
    DualStructureCateType["auto_target_base"] = "auto_target_base";
})(DualStructureCateType || (exports.DualStructureCateType = DualStructureCateType = {}));
